// @ts-nocheck
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'applyModal',
    'modalCompanyName',
    'modalJobName',
    'btnOpenApplyModal',
    'btnCloseApplyModal',
    'applySubmit',
    'closeBtn',
  ];

  connect() {}

  onActionJobLike(event) {
    event.preventDefault();

    const url = event.params.url;
    const jobId = event.params.jobId;
    const currentFavoriteBtn = document.getElementById('js-favorite-button-' + jobId);
    currentFavoriteBtn.classList.add('btn-disabled');
    const method = event.params.method;
    const jobLikeId = event.params.jobLikeId;
    const isApply = event.params.isApply;
    const formData = new FormData();
    formData.append('job_id', jobId);
    formData.append('job_like_id', jobLikeId);
    formData.append('is_apply', isApply);
    Rails.ajax({
      type: method,
      url: url,
      dataType: 'json',
      data: formData,
      success: response => {
        currentFavoriteBtn.outerHTML = response.body.innerHTML;
      },
      error: () => {
        alert('エラーが発生しました。ページをリロードしてください。');
      },
      complete: () => {
        currentFavoriteBtn.classList.remove('btn-disabled');
      },
    });
  }

  onOpenModal(event) {
    const jobId = event.params.jobId;
    const companyName = event.params.companyName;
    const jobName = event.params.jobName;

    this.modalCompanyNameTarget.textContent = companyName;
    this.modalJobNameTarget.textContent = jobName;

    this.applyModalTarget.dataset.jobId = jobId;
    this.btnOpenApplyModalTarget.click();
  }

  onApplyJob(event) {
    event.preventDefault();
    this._setLoading(true);
    const url = event.params.url;
    const jobId = this.applyModalTarget.dataset.jobId;
    const currentApplyBtn = document.getElementById('js-apply-button-' + jobId);
    const favoriteBtn = document.getElementById('js-favorite-button-' + jobId);
    const method = event.params.method;
    const formData = new FormData();
    formData.append('job_id', jobId);
    Rails.ajax({
      type: method,
      url: url,
      dataType: 'json',
      data: formData,
      success: response => {
        // 先にローディング解除して閉じ処理を許可
        this._setLoading(false);
        currentApplyBtn.outerHTML = response.body.innerHTML;
        favoriteBtn.classList.add('d-none');
        this.btnCloseApplyModalTarget.click();
      },
      error: () => {
        this.btnCloseApplyModalTarget.click();
        alert('エラーが発生しました。ページをリロードしてください。');
      },
    });
  }

  onChangeSwitch = () => {
    const elements = document.querySelectorAll('.is-apply');
    elements.forEach(el => el.classList.toggle('d-none'));
  };

  _setLoading(isLoading) {
    this._isLoading = isLoading;
    try {
      if (this.hasApplySubmitTarget) {
        const btn = this.applySubmitTarget;
        const label = btn.querySelector('.js-btn-label');
        const spinner = btn.querySelector('.js-btn-spinner');
        if (isLoading) {
          btn.classList.add('pe-none');
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('af-btn-loading');
          if (label) label.classList.add('opacity-0');
          if (spinner) spinner.classList.remove('d-none');
        } else {
          btn.classList.remove('pe-none');
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('af-btn-loading');
          if (label) label.classList.remove('opacity-0');
          if (spinner) spinner.classList.add('d-none');
        }
      }
      if (this.hasCloseBtnTarget && this.closeBtnTargets?.length) {
        this.closeBtnTargets.forEach(closeBtn => {
          if (isLoading) {
            closeBtn.classList.add('pe-none');
            closeBtn.setAttribute('aria-disabled', 'true');
          } else {
            closeBtn.classList.remove('pe-none');
            closeBtn.removeAttribute('aria-disabled');
          }
        });
      }
    } catch (e) {
      // no-op
    }
  }
}
